const initialState = {
    isModalVisible: false,
  };
  
  const gdprModalReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SHOW_ADD_GDPR_MODAL":
        return { ...state, isModalVisible: true };
  
      case "HIDE_ADD_GDPR_MODAL":
        return { ...state, isModalVisible: false };
  
      default:
        return state;
    }
  };
  
  export default gdprModalReducer;
  